import { render, staticRenderFns } from "./Pedido.vue?vue&type=template&id=c317d61c&scoped=true"
import script from "./Pedido.vue?vue&type=script&lang=js"
export * from "./Pedido.vue?vue&type=script&lang=js"
import style0 from "./Pedido.vue?vue&type=style&index=0&id=c317d61c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c317d61c",
  null
  
)

export default component.exports